// Escape nodes are used for escape sequences. It is rendered as a label with
// the description of the escape and the numeric code it matches when
// appropriate.

import _ from 'lodash';

function hex(value) {
  var str = value.toString(16).toUpperCase();

  if (str.length < 2) {
    str = '0' + str;
  }

  return `(0x${str})`;
}

export default {
  type: 'escape',

  // Renders the escape into the currently set container.
  _render() {
    return this.renderLabel(this.label)
      .then(label => {
        label.select('rect').attr({
          rx: 3,
          ry: 3
        });
        return label;
      });
  },

  setup() {
    let addHex;

    // The escape code. For an escape such as `\b` it would be "b".
    this.code = this.properties.esc.properties.code.textValue;
    // The argument. For an escape such as `\xab` it would be "ab".
    this.arg = this.properties.esc.properties.arg.textValue;
    // Retrieves the label, ordinal value, an flag to control adding hex value
    // from the escape code mappings
    [this.label, this.ordinal, addHex] = _.result(this, this.code);

    // When requested, add hex code to the label.
    if (addHex) {
      this.label = `${this.label} ${hex(this.ordinal)}`;
    }
  },

  // Escape code mappings
  b: ['词边界', -1, false],
  B: ['非词边界', -1, false],
  d: ['数字', -1, false],
  D: ['非数字', -1, false],
  f: ['换页符', 0x0c, true],
  n: ['换行符', 0x0a, true],
  r: ['回车符', 0x0d, true],
  s: ['空白字符', -1, false],
  S: ['非空白字符', -1, false],
  t: ['制表符', 0x09, true],
  v: ['垂直制表符', 0x0b, true],
  w: ['单词字符', -1, false],
  W: ['非单词字符', -1, false],
  1: ['向后引用 (组 = 1)', -1, false],
  2: ['向后引用 (组 = 2)', -1, false],
  3: ['向后引用 (组 = 3)', -1, false],
  4: ['向后引用 (组 = 4)', -1, false],
  5: ['向后引用 (组 = 5)', -1, false],
  6: ['向后引用 (组 = 6)', -1, false],
  7: ['向后引用 (组 = 7)', -1, false],
  8: ['向后引用 (组 = 8)', -1, false],
  9: ['向后引用 (组 = 9)', -1, false],
  0: function() {
    if (this.arg) {
      return [`八进制: ${this.arg}`, parseInt(this.arg, 8), true];
    } else {
      return ['空字符', 0, true];
    }
  },
  c() {
    return [`控制字符-${this.arg.toUpperCase()}`, this.arg.toUpperCase().charCodeAt(0) - 64, true];
  },
  x() {
    return [`0x${this.arg.toUpperCase()}`, parseInt(this.arg, 16), false];
  },
  u() {
    return [`U+${this.arg.toUpperCase()}`, parseInt(this.arg, 16), false];
  }
};
